<template>
	<v-container>
		<v-select
			v-model="$store.state.empresas.selected"
			:items="$store.getters['empresas/lista']"
			:label="$store.getters['empresas/isLoading']?'Cargando Emisores' : 'Elija emisor'"
			solo flat hide-details return-object
			item-value="rut"
			:loading="$store.getters['empresas/isLoading']"
			:prepend-inner-icon="$store.getters['empresas/isLoading']?'' : 'refresh'"
			@click:prepend-inner="$store.dispatch('empresas/getEmpresas')"
			@change="setEmisor"
		>
			<template v-slot:item="{ item }">
				<!-- Ítemes en listado -->
				{{ `${item.rut}${item.dv}`|formatRut }} {{ item.razon_social }}
			</template>
			<template v-slot:selection="{ item }">
				<!-- Ítem actualmente seleccionado -->
				{{ `${item.rut}${item.dv}`|formatRut }} {{ item.razon_social }}
			</template>
		</v-select>
	</v-container>
</template>

<script>

export default {
  name: 'EmpresaSelector',
  data () {
    return {

    }
  },
  methods:{
  	setEmisor: function(empresa){
  		this.$store.dispatch('empresas/selectEmisor', empresa);
  	}
  },
  mounted(){
  	
  }
}
</script>

<style lang="css" scoped>
</style>